export default __webpack_public_path__ + "static/media/crossIcon.9d6bf694.svg";